import React from "react";
import "../assets/styles/Certifications.scss";
import awsCloudPractitioner from "../assets/images/aws-cloud-practitioner.png"; // Adjust path based on your assets
import awsSolutionsArchitect from "../assets/images/aws-solutions-architect.png"; // Adjust path based on your assets

function Certifications() {
  const certifications = [
    {
      title: "AWS Cloud Practitioner (CLF-02)",
      image: awsCloudPractitioner,
      caption: "Foundation-level certification validating knowledge of AWS cloud concepts.",
    },
    {
      title: "AWS Solutions Architect (SAA-C03)",
      image: awsSolutionsArchitect,
      caption: "Associate-level certification for designing and deploying scalable AWS systems.",
    },
  ];

  return (
    <div className="container" id="certifications">
      <div className="certifications-container">
        <h1>Certifications</h1>
        <div className="certifications-grid">
          {certifications.map((cert, index) => (
            <div key={index} className="certification-item">
              <img src={cert.image} alt={`${cert.title} badge`} className="certification-image" />
              <h3>{cert.title}</h3>
              <p className="certification-caption">{cert.caption}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Certifications;